export const UPLOAD_SUCCESS_MESSAGE_TIMEOUT: number =  8 * 1000